import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from './services/translate.service';
import { Translate } from './translate';
import { ReplaySubject } from 'rxjs/';

import { AuthenticationService } from './services/authentication.service';
import { NaviService } from './services/navi.service';
import { ProfileService } from './services/profile.service';
import { BasicError } from './models/error/error';
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements Translate, AfterViewInit {
  private title = 'app';
  public ready: Boolean = false;
  public loginMode: Boolean = false; // which mode should be activated

  constructor(private translate: TranslateService, private auth: AuthenticationService,
    private router: Router, private activatedRoute: ActivatedRoute, private naviService: NaviService, private profile: ProfileService) {

    translate.subscribe(this);
    if (this.naviService.getCurrentPage() !== 'nologin') {
      const testLogin: ReplaySubject<any> = this.auth.reuse();
      testLogin.subscribe(user => {
        if (user instanceof BasicError) {
          this.loginMode = true;
          // Reuse failed. Login will be loaded if not already loaded
          if (this.naviService.getCurrentPage() !== 'login') {
            this.naviService.setCurrentPage('login');
          }
        } else {
          this.loginMode = false;
          // Reuse was successful. Normal page will be loaded
          if (this.naviService.getCurrentPage() === 'index' || this.naviService.getCurrentPage() === 'login') {
            // Decide if dashboard or hcpdashboard should be loaded
            this.profile.getMyRoles().subscribe(roles => {
              if (roles instanceof Array && roles.length > 0) {
                // Go directly to hcpdashboard
                this.naviService.setCurrentPage('hcpdashboard');
              } else {
                this.naviService.setCurrentPage('dashboard');
              }
            });
          }
        }
      });
    }
  }

  public readyTranslate(r: Boolean) {
    this.ready = true;
  }

  public selectLanguage(lang: string): void {
    this.translate.selectLanguage(lang);
  }

  ngAfterViewInit() {

  }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/app.component.ts